import styles from './style.module.scss';
import { ReactNode } from 'react';

interface Props {
    title: string;
    children: ReactNode;
    /** Icon buttons shown at the right of the head bar. */
    actions?: ReactNode;
    /** `inline` wraps the body into rows instead of stacking it — used by the skill tags. */
    layout?: 'stack' | 'inline';
};

/** Titled panel that every section of the account page is built from. */
function InfoCard(props: Props) {
    const { title, actions, children, layout = 'stack' } = props;

    return (
        <div className={styles.card}>
            <div className={styles.card_headbar}>
                <span className={styles.card_headbar_title}>{title}</span>
                {actions && <div className={styles.card_headbar_actions}>{actions}</div>}
            </div>
            <div className={styles.card_main} data-layout={layout}>
                {children}
            </div>
        </div>
    );
};

interface RowProps {
    label: string;
    value: ReactNode;
    /** Education labels are a touch longer than the rest and need more room. */
    wideLabel?: boolean;
    /** Long values move below their label on narrow screens. */
    stackOnMobile?: boolean;
};

/** A label / value pair inside an {@link InfoCard}. */
export function InfoRow(props: RowProps) {
    const { label, value, wideLabel, stackOnMobile } = props;

    return (
        <div
            className={styles.card_main_row}
            data-wide-label={wideLabel}
            data-col-in-mobile={stackOnMobile}
        >
            <span className={styles.card_main_row_prop}>{label}</span>
            <span className={styles.card_main_row_val}>{value}</span>
        </div>
    );
};

export default InfoCard;
